import React, { useEffect, useState } from 'react'
import { LoaderES } from '../../LoaderES';
import { Filtrar } from '../../Filtrar';
import { Pagination } from '../../Pagination';
import { deleteBd, getTableBd, ordenar, updateTableBd } from '../../../config/functions';
import ConfirmDialog, { showConfirmDialog } from '../../utils/ConfirmDialog';
import { toast } from 'react-toastify';
import { Collapse } from 'react-bootstrap';
import './css/rigs.css'
import ModalCampoPozo from '../../DOR/ModalCampoPozo';

const Rigs = ({ 
  broken, collapsed, mobile, colors,
  // Tab props (solo desktop)
  openTabs, setOpenTabs, activeTabId, setActiveTabId, showRigSelector, setShowRigSelector, theme
}) => {

    const [taladros, setTaladros] = useState([])
    const [taladrosInactivos, setTaladrosInactivos] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [documentosFiltrados, setDocumentosFiltrados] = useState([]);

    const [registrosPorPagina, setRegistrosPorPagina] = useState(20);
    const [paginaActual, setPaginaActual] = useState(1);
    const [totalPaginas, setTotalPaginas] = useState(0)
    const [registrosPaginaActual, setRegistrosPaginaActual] = useState([])
    const [open, setOpen] = useState(null);
    const [modalCampoPozo, setModalCampoPozo] = useState(false)

    const [mostrarInactivos, setMostrarInactivos] = useState(false);
    const [filtro, setFiltro] = useState(''); // Estado elevado del filtro

    const [rig, setRig] = useState('')

    const getRigs = async () => {
        setIsLoading(true)
        try {
            const data = await getTableBd('gettldrs')
            if (data && data.length >= 1) {
                data.forEach(t => {
                    const [rig, pozo] = t.vr_tldro_nom.split('-')
                    t.rig = rig.trim()
                    t.pozo = pozo.trim()
                    t.active = parseInt(t.active);
                })
                const activos = data.filter(t => t.active === 1)
                const inactivos = data.filter(t => t.active === 0)
                setTaladros(activos)
                setTaladrosInactivos(inactivos)
            }
        } catch (error) {
            toast.error('Error al cargar los taladros')
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => { getRigs() }, [])

    //---------------------------------------------

    useEffect(() => {
        const newTotalPaginas = Math.ceil(documentosFiltrados.length / registrosPorPagina)
        setTotalPaginas(newTotalPaginas)
        
        // Ajustar paginaActual si está fuera de rango después de actualizar
        if (paginaActual > newTotalPaginas && newTotalPaginas > 0) {
            setPaginaActual(newTotalPaginas)
        }
    }, [documentosFiltrados, registrosPorPagina])

    useEffect(() => {
        const inicio = (paginaActual - 1) * parseInt(registrosPorPagina)
        const fin = inicio + parseInt(registrosPorPagina)
        setRegistrosPaginaActual(documentosFiltrados.slice(inicio, fin))
    }, [paginaActual, totalPaginas, documentosFiltrados])

    //---------------------------------------------

    const handleActiveChange = async (tldro) => {

        const data = {
            nb_tldro_idn: parseInt(tldro.nb_tldro_idn),
            active: tldro.active === 0 ? 1 : 0
        };

        const confirmMessage = (tldro.active === 0)
            ? `¿Desea activar el pozo: ${tldro.pozo} del taladro: ${tldro.rig}?`
            : `¿Desea inactivar el pozo: ${tldro.pozo} del taladro: ${tldro.rig}?`;

        const confirmed = window.confirm(confirmMessage);
        if (confirmed) {
            const response = await updateTableBd('updatetldroactive', data)
            if (response) {
                toast.success(`El pozo ${tldro.pozo} del taladro ${tldro.rig} ha sido ${tldro.active ? 'activado' : 'inactivado'}`);
                getRigs()
            }
        }
    }


    //---------------------------------------------

    const thOrd = (name, col) => {
        return (
            <th scope="col">{name}&nbsp;&nbsp;
                <i className="fa-solid fa-arrow-down-a-z"
                    onClick={() => ordenar(col)}
                    style={{ cursor: "pointer" }}></i>
            </th>
        )
    }

    //---------------------------------------------

    const handleToggleTaladros = () => {
        setMostrarInactivos(!mostrarInactivos);
        // El componente Filtrar manejará automáticamente el filtrado con los nuevos datos
    };

    //---------------------------------------------

    return (
        <>
            {(taladros.length === 0 || isLoading) && <LoaderES />}

            <>
                <div className={`row ${mobile ? 'mb-3' : ''}`}>
                    <div className="col-4 col-md-1">
                        <button
                            title={`Mostrar Taladros ${mostrarInactivos ? 'activos' : 'inactivos'}`}
                            className={`btn fa-solid ${mostrarInactivos ? 'fa-eye' : 'fa-eye-slash'}`}
                            style={{ color: colors.colorFont || '#000000', borderColor: colors.colorFont || '#000000' }}
                            onClick={() => handleToggleTaladros()}
                        />
                    </div>
                    <div className="col-8 col-md-11">
                        <Filtrar
                            documentos={mostrarInactivos ? taladrosInactivos : taladros}
                            setDocumentosFiltrados={setDocumentosFiltrados}
                            setRegistrosFiltrados={setRegistrosPaginaActual}
                            registrosPorPagina={registrosPorPagina}
                            filtro={filtro}
                            setFiltro={setFiltro}
                            colors={colors} />
                    </div>
                </div>

                {mobile
                    ? registrosPaginaActual && registrosPaginaActual.map((r, index) => (
                        <div key={r.nb_tldro_idn}>
                            <table className="table table-sm table-hover table-striped mb-0" style={{ color: colors.colorFont || '#000000' }}>
                                <thead style={{ fontSize: '14px' }}>
                                    <tr >
                                        <th style={{ width: '50px', resize: 'none' }}>
                                            <button className="btn  fa-solid fa-chevron-down btn-sm"
                                                onClick={() => setOpen(open === index ? null : index)}
                                                style={{ color: colors.colorFont || '#000000' }}
                                                aria-controls={"collapse-rig-" + index}
                                                aria-expanded={open === index}
                                            />
                                        </th>
                                        <th style={{ width: '150px', resize: 'none' }}>
                                            <div>{`${r.vr_tldro_nom.split('-')[1]}  `} </div>
                                        </th>

                                    </tr>
                                </thead>
                            </table>

                            <Collapse in={open === index}>
                                <div id={"collapse-rig-" + index} className="mt-2">
                                    <div className="card card-body" style={{ backgroundColor: colors.colorBg || '#000000', borderColor: colors.colorFont || '#000000' }}>
                                        <table className="table table-sm" style={{ color: colors.colorFont || '#000000' }}>
                                            <tbody style={{ fontSize: '12px' }}>

                                                <tr >
                                                    <td>Taladro: </td>
                                                    <td>{r.rig}</td>
                                                </tr>
                                                <tr>
                                                    <td>Pozo:</td>
                                                    <td>{r.pozo}</td>
                                                </tr>
                                                <tr>
                                                    <td>Descipción:</td>
                                                    <td>{r.vr_tldro_des === 'TAladro no configurado, creado automáticamente por el sistemaaa' ?
                                                        'Sin Descripción' :
                                                        r.vr_tldro_des}</td>
                                                </tr>

                                                <tr>
                                                    <td>Opciones</td>
                                                    <td>
                                                        <div className="btn-group">
                                                            <button className='fa-solid fa-pen btn btn-sm btn-outline-info'
                                                            />
                                                            <button className='fa-solid fa-trash-can btn btn-sm btn-outline-danger'
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </Collapse>

                        </div>
                    ))
                    : <div className="table-responsive mt-3">
                        <table className="table table-sm table-hover table-bordered align-middle" id='myTable'
                            style={{ color: colors.colorFont || '#000000' }}>
                            <thead className='text-center'>
                                <tr>
                                    {thOrd('id', 0)}
                                    {thOrd('Taladro', 1)}
                                    {thOrd('Pozo', 2)}
                                    {thOrd('Descripción', 3)}
                                    <th>Activo</th>
                                    <th>Opciones</th>

                                </tr>
                            </thead>
                            <tbody className='text-center' style={{ fontSize: '11px' }}>
                                {registrosPaginaActual.map(tldro => (
                                    <tr key={tldro.nb_tldro_idn} className={`${tldro.active === 0 ? 'table-danger' : ''}`}>
                                        <td>{tldro.nb_tldro_idn}</td>
                                        <td>{tldro.rig}</td>
                                        <td>{tldro.pozo}</td>
                                        <td>{tldro.vr_tldro_des === 'TAladro no configurado, creado automáticamente por el sistemaaa' ?
                                            'Sin Descripción' :
                                            tldro.vr_tldro_des}
                                        </td>
                                        <td className="d-flex justify-content-center align-items-center">
                                            <div className="form-check form-switch">
                                                <input type="checkbox" className="form-check-input form-check-lg"
                                                    checked={tldro.active}
                                                    onChange={() => handleActiveChange(tldro)}
                                                />
                                            </div>
                                        </td>
                                        <td>
                                            <div className="btn-group">

                                                <button
                                                    title='Campo-Pozo'
                                                    className='fa-solid fa-list-check btn btn-sm btn-outline-primary'
                                                    onClick={() => {
                                                        setRig(tldro)
                                                        setModalCampoPozo(true)
                                                    }}
                                                />
                                                <button
                                                    title='Editar'
                                                    className='fa-solid fa-pen btn btn-sm btn-outline-info'
                                                    onClick={() => toast.info('Función en Desarrollo')}
                                                />
                                                <button
                                                    title='Eliminar'
                                                    className='fa-solid fa-trash-can btn btn-sm btn-outline-danger'
                                                    onClick={() => {
                                                        showConfirmDialog(
                                                            `¿Está seguro de eliminar el taladro ${tldro.rig} - ${tldro.pozo}? Se eliminarán TODOS los datos asociados (variables, gráficas, alarmas, reportes diarios, medidas, etc). Esta acción NO se puede deshacer.`,
                                                            async () => {
                                                                try {
                                                                    toast.info('Eliminando taladro, esto puede tardar...');
                                                                    await deleteBd(tldro.nb_tldro_idn, 'deletetldro');
                                                                    toast.success(`Taladro ${tldro.rig} - ${tldro.pozo} eliminado correctamente`);
                                                                    getRigs();
                                                                } catch (error) {
                                                                    toast.error('Error al eliminar el taladro');
                                                                }
                                                            }
                                                        );
                                                    }}
                                                />

                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                }


            </>

            <Pagination
                paginaActual={paginaActual}
                totalPaginas={totalPaginas}
                setPaginaActual={setPaginaActual}
                registrosPorPagina={registrosPorPagina}
                setRegistrosPorPagina={setRegistrosPorPagina}
                documentosFiltrados={documentosFiltrados}
                broken={broken}
                collapsed={collapsed}
                mobile={mobile}
                colors={colors}
            />


            <ModalCampoPozo
                show={modalCampoPozo}
                handleClose={() => setModalCampoPozo(false)}
                rig={rig}
            />

            <ConfirmDialog />

        </>
    )
}

export default Rigs